<template>
  <div style="font-size: 0.32rem">
    <img class="w" src="../assets/images/wxjq_imgs/bg.png" alt="" />
    <div class="wxjq_box flex ai_c">
      <div class="wxjq_bg"></div>
      <img class="wxjq_icon" src="../assets/images/wxjq_imgs/icon.png" alt="" />
    </div>
    <div class="fw500 fs20 mt24 tc">正在进入微信借钱，请稍候</div>
    <div class="wxjq_tip">
      <div class="center">
        <img
          style="width: 0.72rem"
          src="../assets/images/wxjq_imgs/line1.png"
          alt=""
        />
        <div class="fs16" style="margin: 0 0.32rem">温馨提示</div>
        <img
          style="width: 0.72rem"
          src="../assets/images/wxjq_imgs/line2.png"
          alt=""
        />
      </div>
      <div class="mt10 fs14">
        阅读“风险提示后点击“发起聊天“进入微信客服办理。请勿接听陌生电话和打开短信里的链接。
      </div>
    </div>
  </div>
</template>

<script>
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common";

export default {
  name: "Wxjq",
  data() {
    return {
      ysxy: "",
    };
  },
  created() {
    const _json = JSON.parse(localStorage.getItem("wxjq_date") || "{}");
    setTimeout(() => {
      toRedirectUrlAndSaveRecordNoDebounce(_json.linkUrl, {
        productId: _json.id,
        showPage: _json.showPage,
      });
    }, 2800);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.w {
  width: 100%;
}
.fs20 {
  font-size: 0.4rem;
}
.fw500 {
  font-weight: 500;
}
.tc {
  text-align: center;
}
.fs14 {
  font-size: 0.28rem;
}
.mt10 {
  margin-top: 0.2rem;
}
.flex {
  display: flex;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ai_c {
  align-items: center;
}
.wxjq_box {
  width: 5.6rem;
  height: 0.16rem;
  margin: 0.34rem auto;
  background: #dfdfdf;
  border-radius: 0.08rem;
  .wxjq_bg {
    background: linear-gradient(270deg, #ffa57c 0%, #ff7530 100%);
    border-radius: 0.08rem;
    height: 0.16rem;
    animation: move_img 3s linear forwards;
  }
}
.wxjq_icon {
  width: 0.6rem;
  height: 0.6rem;
  margin-left: -0.3rem;
}
@keyframes move_img {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.wxjq_tip {
  margin: 1.2rem 0.32rem;
  padding: 0.48rem 0.4rem;
  background: #fff8f2;
  border-radius: 0.16rem;
  color: #ff7119;
  line-height: 1.5;
}
</style>
